import { gql } from 'graphql-tag';
import { COLLECTION_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/collection';
import { CONTENT_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/content';
export const TAG_FRAGMENT = gql `
  fragment TagFragment on Tag {
    __typename
    id
    name
    items {
      __typename
      id
      parentId
      entityId
      entityType
    }
  }
`;
export const TAGS_GET = gql `
  ${TAG_FRAGMENT}
  query allTags {
    tags: allTags {
      ...TagFragment
    }
  }
`;
export const TAG_GET = gql `
  ${COLLECTION_SHALLOW_FRAGMENT}
  ${CONTENT_SHALLOW_FRAGMENT}
  query getTag($id: ID!) {
    tag: Tag(id: $id) {
      __typename
      id
      name
      items {
        __typename
        id
        parentId
        entityId
        entityType
        item {
          ... on Collection {
            ...CollectionShallowFragment
          }
          ... on Content {
            ...ContentShallowFragment
          }
        }
      }
    }
  }
`;
export const TAG_CREATE = gql `
  ${TAG_FRAGMENT}
  mutation createTag($item: TagItemDto, $name: String!) {
    tag: createTag(item: $item, name: $name) {
      ...TagFragment
    }
  }
`;
export const TAG_DELETE = gql `
  ${TAG_FRAGMENT}
  mutation deleteTag($id: ID!) {
    tag: deleteTag(id: $id) {
      ...TagFragment
    }
  }
`;
//# sourceMappingURL=tag.js.map